import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

import Garage from '../../../assets/svg/Garage.jpg'

import WhiteLock from '../../../assets/Icons/Lock-white.png';
import YellowLock from '../../../assets/Icons/Lock-yellow.png';
import YellowUnLock from '../../../assets/Icons/UnLockYellow.png';
import GrageClosedYellow from '../../../assets/Icons/GarageClosedYellow-01.png';
import GrageOpenedYellow from '../../../assets/Icons/GarageOpenedYellow-01.png';
import GrageClosedWhite from '../../../assets/Icons/GarageClosed-01.png';
import GrageOpenedWhite from '../../../assets/Icons/GarageOpenedWhite-01.png';
import GateClosedYellow from '../../../assets/Icons/GateClosedYellow-01.png';
import GateClosedWhite from '../../../assets/Icons/GateClosedWhite-01.png';
import GateOpenedYellow from '../../../assets/Icons/GateOpenedYellow-01.png';
import GateOpenedWhite from '../../../assets/Icons/GateOpenedWhite-01.png';



export const Icons = {
  Garage,
  WhiteLock,
  YellowLock,
  YellowUnLock,
  GrageClosedYellow,
  GrageOpenedYellow,
  GrageClosedWhite,
  GrageOpenedWhite,
  GateClosedYellow,
  GateClosedWhite,
  GateOpenedYellow,
  GateOpenedWhite,
}
export const TabMenus = ["Camers", "Locks", "Garage Doors", "Gates"]


export const lightsMenu = [
  { name: "front lobby", type: "East Wing" },
  { name: "garage doors", type: "Front View" },
  { name: "grage", type: "inside view" },
  { name: "First Floor", type: "Near Stairs" },
  { name: "patio door ", type: "Blue bulb" },
  { name: "patio door ", type: "Blue bulb" },
  { name: "patio door ", type: "Blue bulb" },
  { name: "patio door ", type: "Blue bulb" },
  { name: "patio door ", type: "Blue bulb" },
]

export const AvatarStyle = {
  width: 31,
  height: 31,
  marginRight: "10px"
}
export const LightsType = styled(IconButton)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: "#FFFFFF",
  width: 170,
  height: 70,
  borderRadius: "10px",
  marginRight: "20px",
  display: "inline-block"

}));

export const ScenesItem = styled(IconButton)(({ theme }) => ({
  backgroundColor: "#3E3E3E",
  // ...theme.typography.body2,
  // padding: theme.spacing(1),
  // textAlign: 'center',
  color: "#FFFFFF",
  width: 200,
  height: 60,
  borderRadius: "10px",
  // marginRight: "20px",


}));

export const FloorItem = styled(IconButton)(({ theme }) => ({
  backgroundColor: "#3E3E3E",
  color: "#FFFFFF",
  width: 200,
  height: 128,
  borderRadius: "10px",
  display: "grid",
  gridGap: "25px",
  justifyContent: "space-between",
  alignContent: "center"
}));
// flex-direction: column;
//     /* display: flex; */
//     align-content: center;
//     justify-content: space-between;

export const cardStyle = (theme: any) => {
  return {
    [theme.breakpoints.only('il')]: {
      width: 1045
    },
    [theme.breakpoints.down('ip')]: {
      width: 680
    },
    [theme.breakpoints.down('ip')]: {
      width: 305
    },
  }
}